export default __webpack_public_path__ + "static/media/4000.a1e235d9.jpg";